/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ChromeBarItemUploadStatusWidget", ["ItemWidget", "WidgetFactory"], function (context, cls) {
  /**
   * Close Button in ChromeBar
   * @class ChromeBarItemUploadStatusWidget
   * @memberOf classes
   * @extends classes.ItemWidget
   */
  cls.ChromeBarItemUploadStatusWidget = context.oo.Class(cls.ItemWidget, function ($super) {
    return /** @lends classes.ChromeBarItemUploadStatusWidget.prototype */ {
      __name: "ChromeBarItemUploadStatusWidget",
      __templateName: "ItemWidget",

      _active: false,
      _count: 0,

      /**
       * Change style when idle
       */
      setIdle: function () {
        if (this._count > 0) {
          this._count--;
        }
        if (this._count === 0) {
          this.removeClass("processing");
          this.setHidden(true);
        }
      },

      /**
       * Change style when processing
       */
      setProcessing: function () {
        this._count++;
        this.addClasses("processing");
        this.setHidden(false);
      },

      /**
       * Handle file upload progress
       * @param {Object} progress object info
       * @param {number} progress.loaded amount already uploaded
       * @param {number} progress.total total amount of data
       */
      setProgress: function (progress) {
        const percent = Math.round((progress.loaded * 100) / progress.total);
        this.setText(percent + "%");
        this.setImage();
        const loadingBar = document.querySelector(".loading-bar");
        loadingBar.setAttribute("percent", percent.toString());
        loadingBar.style.setProperty("--loadingPercent", `${percent.toString()}%`);
        if (percent === 100) {
          loadingBar.removeAttribute("percent");
        }
        this.setTitle(
          `${gbc.I18NService.t("gwc.file.upload.processing")} (${this.formatFileSize(progress.loaded)}/${this.formatFileSize(progress.total)})`
        );
      },

      /**
       * Display human-readable value
       * @param {Number} bytes
       * @param {Number?} decimalPoint - length of the decimal part
       * @return {string} human readable value
       */
      formatFileSize: function (bytes, decimalPoint) {
        if (bytes === 0) {
          return "0 Bytes";
        }
        const k = 1000,
          dm = decimalPoint || 2,
          sizes = ["Bytes", "KB", "MB", "GB", "TB"],
          i = Math.floor(Math.log(bytes) / Math.log(k));
        return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
      }
    };
  });
  cls.WidgetFactory.registerBuilder("ChromeBarItemUploadStatus", cls.ChromeBarItemUploadStatusWidget);
});
